import { useFrontendTool } from '@copilotkit/react-core';

import {
  PROPOSE_CODE_EVENT,
  ProposeCodeEventDetail,
} from 'pipelines/components/CodeEditor/CodeEditorContext';

export function useApplyCustomFunctionCodeTool() {
  useFrontendTool({
    name: 'applyCustomFunctionCode',
    description:
      'Apply generated custom function code to the code editor. This will show a diff view where the user can review and accept or reject the changes. CRITICAL: Use this tool ONLY with code generated using generate_custom_function tool, and ONLY when the user context shows there is currently open custom function node code.',
    parameters: [
      {
        name: 'nodeID',
        type: 'string',
        description:
          'ID of the custom function node to apply the code to. This should match the nodeID from the currently open custom function node code context.',
        required: true,
      },
      {
        name: 'code',
        type: 'string',
        description: 'The Python code to apply to the custom function node',
        required: true,
      },
    ],
    handler: async ({ nodeID, code }) => {
      const event = new CustomEvent<ProposeCodeEventDetail>(
        PROPOSE_CODE_EVENT,
        {
          detail: { nodeID, code },
        }
      );
      window.dispatchEvent(event);
      return `Code proposed for node ${nodeID}. User can now review and accept or reject the changes in the diff view.`;
    },
  });
}
